import styled, { css } from 'styled-components';
import { OnlineThemeType } from '../../themes/online';

function buttonStyle(theme: OnlineThemeType, buttonTheme: string) {
  switch (buttonTheme) {
    case 'blue':
      return css`
        background-color: ${theme.colors.primaryBright};
        color: ${theme.colors.white};

        &:hover {
          background-color: ${theme.colors.primary};
        }
      `;
    case 'gray':
      return css`
        background-color: ${theme.colors.grayWhite};
        color: ${theme.colors.primaryBright};

        &:hover {
          filter: brightness(0.98);
        }
      }
      `;
    default:
      return css`
        background-color: ${theme.colors.grayWhite};
        color: ${theme.colors.primaryBright};
      `;
  }
}

// tslint:disable-next-line:variable-name
const SButton = styled.button<{ buttonTheme: string; disabled?: boolean }>(
  ({ theme, buttonTheme, disabled = false }) => css`
    font-family: Poppins;
    cursor: pointer;
    height: 44px;
    width: 119px;
    display: flex;

    justify-content: center;
    align-items: center;
    margin-top: 33px;
    border: 0px solid;
    border-radius: 50px;
    font-weight: 700;
    font-size: 17px;
    line-height: 1.56;

    ${buttonStyle(theme, buttonTheme)}

    ${disabled
      ? css`
          background-color: ${theme.colors.disabledBG};
          cursor: default;
          pointer-events: none;
          color: ${theme.colors.disabledText};

          & span {
            font-family: 'Poppins';
            color: ${theme.colors.disabledText};
            font-weight: 800;
          }
        `
      : ''};
  `
);

export default SButton;
